import React from 'react';
import PropTypes from 'prop-types';
const UIColorBrandBox = ({ colorUsage, colorProps, colorName, colorHex, whiteText }) => (<div className="d-flex flex-column brand-box shadow-uniform rounded m-4" style={{
        backgroundColor: colorHex,
    }}>
        <div className={`px-7 py-9${whiteText === true ? ' text-white' : ''} d-flex align-items-center justify-content-center`}>
            <p className="p-0 no-gutters">{colorUsage}</p>
        </div>
        <div className="bg-white p-7 mt-auto">
            <h3 className="brand-box__title">
                <div dangerouslySetInnerHTML={{
        __html: colorProps,
    }}/>
            </h3>
            <p>{colorName}</p>
            <p>{colorHex}</p>
        </div>
    </div>);
UIColorBrandBox.propTypes = {
    colorUsage: PropTypes.string.isRequired,
    colorProps: PropTypes.string.isRequired,
    colorName: PropTypes.string.isRequired,
    colorHex: PropTypes.string.isRequired,
    whiteText: PropTypes.bool,
};
UIColorBrandBox.defaultProps = {
    whiteText: true,
};
export default UIColorBrandBox;
